var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * RotateVertical component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconRotateVertical extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.49304 15.4879C8.90162 15.4198 9.28804 15.6958 9.35613 16.1044C9.43311 16.5663 9.55959 17.2061 9.74444 17.8881C9.8528 18.2879 9.61655 18.6998 9.21677 18.8082C8.81698 18.9165 8.40504 18.6803 8.29668 18.2805C8.09604 17.5403 7.95975 16.8503 7.87653 16.3509C7.80844 15.9424 8.08446 15.5559 8.49304 15.4879Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.91777 20.5857C10.2469 20.3342 10.7176 20.3972 10.9691 20.7264C11.3441 21.2172 11.686 21.3953 11.997 21.3953C12.3005 21.3953 12.6519 21.2282 13.0444 20.7221C13.2982 20.3947 13.7694 20.3352 14.0967 20.589C14.424 20.8429 14.4836 21.314 14.2297 21.6413C13.6846 22.3442 12.9431 22.8953 11.997 22.8953C11.0222 22.8953 10.2904 22.3089 9.77711 21.637C9.52565 21.3078 9.58862 20.8372 9.91777 20.5857Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.45148 8.50512C8.46509 8.50817 8.47886 8.51086 8.49278 8.51318C8.6519 8.5397 8.80765 8.51403 8.94256 8.44867L11.9644 7.22798C12.3485 7.07284 12.5341 6.63573 12.3789 6.25167C12.2238 5.8676 11.7867 5.68203 11.4026 5.83717L9.63126 6.55271C9.79555 5.87684 10.0184 5.12935 10.3081 4.45691C10.5631 3.86529 10.8506 3.37775 11.1602 3.04881C11.4637 2.72641 11.738 2.60547 11.9978 2.60547C12.3055 2.60547 12.6633 2.77776 13.0622 3.30096C13.4608 3.82372 13.8222 4.60284 14.1239 5.56681C14.6531 7.2577 14.9524 9.36557 15.0163 11.248H1.85547C1.44126 11.248 1.10547 11.5838 1.10547 11.998C1.10547 12.4123 1.44126 12.748 1.85547 12.748H15.7188C15.7388 12.7496 15.759 12.7505 15.7794 12.7505C15.7997 12.7505 15.8199 12.7496 15.8399 12.748H22.1455C22.5597 12.748 22.8955 12.4123 22.8955 11.998C22.8955 11.5838 22.5597 11.248 22.1455 11.248H16.5171C16.4531 9.24383 16.137 6.97722 15.5554 5.1188C15.2287 4.07491 14.8032 3.11037 14.255 2.39143C13.7071 1.67292 12.9581 1.10547 11.9978 1.10547C11.1954 1.10547 10.5523 1.50616 10.0679 2.02074C9.58978 2.52877 9.2192 3.19355 8.9306 3.86331C8.61052 4.60612 8.36765 5.41171 8.18924 6.13485L7.00355 4.76259C6.73274 4.44917 6.25912 4.41463 5.9457 4.68544C5.63228 4.95625 5.59773 5.42987 5.86855 5.74329L8.04581 8.26313C8.15408 8.38844 8.29731 8.47104 8.45148 8.50512Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.6146 14.7092C16.0263 14.7545 16.3234 15.125 16.278 15.5367C16.2352 15.9255 16.141 16.4949 16.0353 17.0217C15.9336 17.5281 15.8056 18.0771 15.6829 18.3839C15.5292 18.7685 15.0927 18.9557 14.7081 18.8019C14.3235 18.6481 14.1364 18.2117 14.2901 17.8271C14.3542 17.6667 14.4597 17.2493 14.5646 16.7265C14.6654 16.2242 14.7508 15.7017 14.7871 15.3726C14.8324 14.9609 15.2029 14.6638 15.6146 14.7092Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconRotateVertical.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconRotateVertical.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconRotateVertical.prototype, "size", void 0);
if (customElements.get('cat-icon-rotate-vertical') === undefined) {
    customElements.define('cat-icon-rotate-vertical', BlocksIconRotateVertical);
}
